'use strict';

require('jquery.inputmask/dist/jquery.inputmask.bundle.js');

module.exports = function () {
	$('[type="tel"]').each(function () {



		let $input = $(this);



		$input.inputmask('+7 (999) 999-99-99', {
			'clearIncomplete': true
		});



		$input.on('input', function () {
			let status = $input.inputmask('isComplete');

			if (status) {
				$input.addClass('complete');
			} else {
				$input.removeClass('complete');
			}
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/inputMask.js
 **/